class ImgObject {
    constructor(fileName,iso,aperture,shutter,focal,device){
        this.compressedPath = `./imgs/compressed/${fileName}`;
        this.ultraCompressedPath = `./imgs/ultraCompressed/${fileName}`;
        this.iso = iso;
        this.aperture = aperture;
        this.shutter = shutter;
        this.focal = focal;
        this.device = device;
    }
}

const imgArray = [
    new ImgObject("IMG_1292.jpeg"),
    new ImgObject("IMG_7873.jpeg"),
    new ImgObject("IMG_1344.jpeg"),
    new ImgObject("IMG_1787.jpeg"),
    new ImgObject("IMG_4737.jpeg"),
    new ImgObject("IMG_5043.jpeg"),
    new ImgObject("IMG_5199.jpeg"),
    new ImgObject("IMG_5304.jpeg"),
    new ImgObject("IMG_5258.jpeg"),
    new ImgObject("IMG_7869.jpeg"),
];

class ImgObject2 {
    constructor(fileName,tags){
        this.imgName = fileName;
        this.fullSize = `../imgs/new/fullSize/${fileName}`;
        this.px2000 = `../imgs/new/2000px/${fileName}`;
        this.px1000 = `../imgs/new/1000px/${fileName}`;
        this.px100 = `../imgs/new/100px/${fileName}`;
        this.px20 = `../imgs/new/20px/${fileName}`;
        this.tags = tags;
    }
}




const imgArray2 = [
    new ImgObject2("1-IMG_5139.jpg",['vehicles','japan']),
    new ImgObject2("IMG_3464.jpg",['animals','architecture','japan']),
    new ImgObject2("IMG_3833.jpg",['street','architecture','japan']),
    new ImgObject2("IMG_4267.jpg",['architecture','japan']),
    new ImgObject2("IMG_4606.jpg",['architecture','japan']),
    new ImgObject2("4-IMG_5122.jpg",['vehicles','japan']),
    new ImgObject2("IMG_3497.jpg",['street','architecture','japan']),
    new ImgObject2("IMG_3870.jpg",['animals','nature','japan']),
    new ImgObject2("IMG_4279.jpg",['nature','architecture','japan']),
    new ImgObject2("IMG_4694.jpg",['animals','architecture','japan']),
    new ImgObject2("5-IMG_5121.jpg",['vehicles','japan']),
    new ImgObject2("IMG_3622.jpg",['animals','architecture','japan']),
    new ImgObject2("IMG_3911.jpg",['animals','nature','japan']),
    new ImgObject2("IMG_4329.jpg",['street','architecture','japan']),
    new ImgObject2("IMG_5069.jpg",['street','vehicles','japan']),
    new ImgObject2("DSC00176.jpg",['animals']),
    new ImgObject2("IMG_3655.jpg",['nature','architecture','japan']),
    new ImgObject2("IMG_3930.jpg",['animals','nature','japan']),
    new ImgObject2("IMG_4419.jpg",['architecture','japan']),
    new ImgObject2("IMG_7869.jpg",['animals','corfu']),
    new ImgObject2("DSC00310.jpg",['nature']),
    new ImgObject2("IMG_3701.jpg",['animals','nature','japan']),
    new ImgObject2("IMG_4006.jpg",['nature','architecture','japan']),
    new ImgObject2("IMG_4508-2.jpg",['street','vehicles','architecture','japan']),
    new ImgObject2("IMG_7871-2.jpg",['animals','corfu']),
    new ImgObject2("IMG_3150.jpg",['nature','architecture','japan']),
    new ImgObject2("IMG_3721.jpg",['nature','animals','architecture','japan']),
    new ImgObject2("IMG_4137.jpg",['architecture','japan']),
    new ImgObject2("IMG_4511.jpg",['vehicles','japan']),
    new ImgObject2("IMG_7872.jpg",['corfu']),
    new ImgObject2("IMG_3276.jpg",['architecture','japan']),
    new ImgObject2("IMG_3751.jpg",['animals','nature','japan']),
    new ImgObject2("IMG_4145.jpg",['nature','architecture','japan']),
    new ImgObject2("IMG_4528.jpg",['architecture','japan']),
    new ImgObject2("IMG_7877.jpg",['animals']),
    new ImgObject2("IMG_3307.jpg",['nature','architecture','japan']),
    new ImgObject2("IMG_3754.jpg",['vehicles','japan']),
    new ImgObject2("IMG_4147.jpg",['architecture','japan']),
    new ImgObject2("IMG_4533.jpg",['vehicles','architecture','japan']),
    new ImgObject2("IMG_3405.jpg",['japan']),
    new ImgObject2("IMG_3770.jpg",['japan']),
    new ImgObject2("IMG_4234.jpg",['animals','nature','japan']),
    new ImgObject2("IMG_4546.jpg",['architecture','japan']),
    new ImgObject2("IMG_3454.jpg",['street','architecture','japan']),
    new ImgObject2("IMG_3789.jpg",['animals','nature','japan']),
    new ImgObject2("IMG_4246.jpg",['nature','architecture','japan']),
    new ImgObject2("IMG_4569.jpg",['architecture','japan']),
    new ImgObject2("DSC00354.jpg",['animals']),
    new ImgObject2("DSC00356.jpg",['animals']),
    new ImgObject2("DSC00402.jpg",['animals']),
];

export { imgArray , imgArray2 };